export const NEW_CHAT_SOUND_BLOCKED = 'NEW_CHAT_SOUND_BLOCKED';
export const DISMISS_CHAT_SOUND_WARNING = 'DISMISS_CHAT_SOUND_WARNING';

export default function soundWarning(state = false, action) {
    switch (action.type) {
        case NEW_CHAT_SOUND_BLOCKED:
            return true;
        case DISMISS_CHAT_SOUND_WARNING:
            return false;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/services/notification/soundWarning.js